class VerticalBrandingScroll {
  constructor() {
    this.letters = document.querySelectorAll('.letter');
    this.maxRotation = 90; // Maximum rotation in degrees
    this.navbarHeight = 180;
    console.log('VerticalBrandingScroll initialized, found letters:', this.letters.length);
    this.init();
  }

  init() {
    if (this.letters.length === 0) {
      console.error('No letters found for rotation animation');
      return;
    }
    
    console.log('Setting up scroll listener for', this.letters.length, 'letters');
    
    // Bind scroll event
    window.addEventListener('scroll', () => this.handleScroll(), { passive: true });
    
    // Initial call to set starting position
    this.handleScroll();
  }

  handleScroll() {
    // Get scroll progress (0 to 1)
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    const documentHeight = document.documentElement.scrollHeight - window.innerHeight;
    const scrollProgress = Math.min(scrollTop / documentHeight, 1);

    console.log('Scroll progress:', scrollProgress, 'scrollTop:', scrollTop);

    // Get the container and adjust its positioning for progressive reveal
    const container = document.querySelector('.vertical-branding');
    const textElement = document.querySelector('.vertical-branding__text');
    
    if (container && textElement) {
      // Get the actual rendered height of the text element
      const actualTextHeight = textElement.offsetHeight;
      const viewportHeight = window.innerHeight;
      
      // Try to find the footer element using the correct selector
      const footer = document.querySelector('.footer__content-bottom') || 
                    document.querySelector('footer') || 
                    document.querySelector('.footer');
      
      let endTop;
      
      if (footer) {
        const footerRect = footer.getBoundingClientRect();
        const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
        const footerTop = footerRect.top + scrollTop; // Absolute position of footer
        
        // Calculate a reasonable end position that keeps text visible
        // The text should stop when it reaches the footer area relative to viewport
        const footerViewportPosition = footerRect.top; // Footer position relative to current viewport
        const maxVisibleBottom = viewportHeight - 50; // Keep 100px margin from viewport bottom
        
        if (footerViewportPosition > 0 && footerViewportPosition < viewportHeight) {
          // Footer is visible in viewport, position text above it
          endTop = Math.min(footerViewportPosition - actualTextHeight - 50, maxVisibleBottom - actualTextHeight);
        } else {
          // Footer not in viewport, use viewport-based positioning
          endTop = maxVisibleBottom - actualTextHeight;
        }
        
        console.log('Using footer-based positioning. Footer viewport pos:', footerViewportPosition, 'End top:', endTop);
      } else {
        // No footer found, use viewport-based positioning
        endTop = viewportHeight - actualTextHeight - 20; // 100px margin from bottom
        console.log('No footer found, using viewport-based positioning. End top:', endTop);
      }
      
      // At scroll 0%: position so only T is visible (start at navbar height)
      // At scroll 100%: position based on footer or viewport
      const startTop = this.navbarHeight;

      console.log('Start top:', startTop, 'End top:', endTop, 'Text height:', actualTextHeight);

      // Interpolate between start and end positions
      const currentTop = startTop + (endTop - startTop) * scrollProgress;

      // Ensure we don't go above the end position
      const finalTop = Math.max(endTop, Math.min(startTop, currentTop));

      container.style.setProperty('top', `${finalTop}px`, 'important');

      console.log('Setting container top to:', finalTop, 'px');
    }

    // Apply rotation to each letter (all letters are always visible, just positioned)
    console.log('Applying rotation to', this.letters.length, 'letters');
    this.letters.forEach((letter, index) => {
      // Calculate rotation for this letter (0 to maxRotation degrees)
      const rotation = scrollProgress * this.maxRotation;
      
      // Apply rotation transform (all letters are always visible)
      letter.style.setProperty('transform', `translateX(0) rotate(${rotation}deg)`, 'important');
      
      if (index === 0) { // Log first letter for debugging
        console.log('Letter T rotation:', rotation, 'degrees, scroll progress:', scrollProgress);
      }
    });

    // Try controlling vertical spacing via line-height on the parent container
    if (textElement) {
      // Create breathing effect: 0.8 -> 1.0 -> 0.6
      const startSpacing = 0.8; // Top of page
      const midSpacing = 1.1;   // Middle of page (maximum)
      const endSpacing = 0.6;   // Bottom of page
      
      // Use sine wave for expansion, but adjust for asymmetric start/end values
      const sineValue = Math.sin(scrollProgress * Math.PI); // Creates 0->1->0 curve
      
      // Calculate current line-height with different start and end values
      let currentLineHeight;
      if (scrollProgress <= 0.5) {
        // First half: 0.8 -> 1.0
        const localProgress = scrollProgress * 2; // Scale to 0-1 for first half
        const localSine = Math.sin(localProgress * Math.PI * 0.5); // Quarter sine wave
        currentLineHeight = startSpacing + (midSpacing - startSpacing) * localSine;
      } else {
        // Second half: 1.0 -> 0.6
        const localProgress = (scrollProgress - 0.5) * 2; // Scale to 0-1 for second half
        const localSine = Math.cos(localProgress * Math.PI * 0.5); // Quarter cosine wave
        currentLineHeight = endSpacing + (midSpacing - endSpacing) * localSine;
      }
      
      // Apply line-height to control vertical spacing
      textElement.style.setProperty('line-height', `${currentLineHeight}`, 'important');
      textElement.style.setProperty('letter-spacing', '0', 'important');
      textElement.style.setProperty('gap', '0', 'important');
      
      console.log('Scroll progress:', scrollProgress.toFixed(3), 'Line-height:', currentLineHeight.toFixed(3));
    }
  }
}

// Initialize when DOM is loaded
function initVerticalBrandingScroll() {
  console.log('Attempting to initialize VerticalBrandingScroll');
  new VerticalBrandingScroll();
}

// Try multiple initialization methods
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initVerticalBrandingScroll);
} else {
  // DOM already loaded
  initVerticalBrandingScroll();
}

// Also try after a short delay to ensure everything is loaded
setTimeout(initVerticalBrandingScroll, 1000);
